var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "raft-radio",
    attrs: {
      "data-test": _vm.dataTest
    }
  }, [_vm._l(_vm.options, function (option) {
    return [_vm.disabled ? _c('input', {
      key: '' + _vm.name + option.value + '-input',
      class: _vm.small ? 'small' : '',
      attrs: {
        "disabled": "",
        "type": "radio",
        "name": _vm.name,
        "data-test": 'pill-' + option.value,
        "id": '' + _vm.name + '-' + (option.id || option.text)
      },
      domProps: {
        "checked": _vm.selected === option.value || _vm.value === option.value,
        "value": option.value
      }
    }) : _c('input', {
      key: '' + _vm.name + option.value + '-input',
      class: _vm.small ? 'small' : '',
      attrs: {
        "type": "radio",
        "name": _vm.name,
        "data-test": 'pill-' + option.value,
        "id": '' + _vm.name + '-' + (option.id || option.text)
      },
      domProps: {
        "checked": _vm.selected === option.value || _vm.value === option.value,
        "value": option.value
      },
      on: {
        "change": _vm.handleRadio
      }
    }), _vm._v(" "), _c('label', {
      key: '' + _vm.name + option.value + '-label',
      staticClass: "custom-control-label",
      class: _vm.small ? 'small' : '',
      attrs: {
        "for": '' + _vm.name + '-' + (option.id || option.text)
      }
    }, [_vm._v("\n      " + _vm._s(option.text || "missing text") + "\n    ")])];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }